<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">                      
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='58vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>
                                  <e-column field='bill_id' headerText='訂購單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                  <e-column field='bill_date' headerText='訂購日期' width='180'></e-column>                                       
                                  <e-column field='bill_state_name' headerText='單況' width='80'></e-column>          
                                  <e-column field='pages' textAlign="Right" format="N0"  headerText='張數合計' width='140' ></e-column>       
                                  <e-column field='bus_person_id' headerText='業務員編號' width='140'></e-column>       
                                  <e-column field='enterprise_id' headerText='企業編號' width='140'></e-column>    
                                  <e-column field='enterprise_name' headerText='企業名稱' width='320'></e-column>              
                                  <e-column field='customer_po' headerText='客戶PO' width='140'></e-column>  
                                  <e-column field='contact' headerText='聯絡人員' width='140'></e-column>  
                                  <e-column field='contact_phone' headerText='連絡電話' width='140'></e-column>  
                                  <e-column field='fax' headerText='傳真號碼' width='220'></e-column>  
                                  <e-column field='deliver_mehtod' headerText='交貨方式' width='220'></e-column>  
                                  <e-column field='deliver_country' headerText='國別' width='90'></e-column>  
                                  <e-column field='deliver_address' headerText='送貨地址' width='280'></e-column>  
                                  <e-column field='memo' headerText='備註' width='260'></e-column>                             
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增標籤訂購" : "修改標籤訂購"' :buttons='e_buttons' 
                        width='60%'>
                        <div formGroup="orderForm">                       
                            <div class="form-row">                          
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">訂購單號</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_bill_id" :enabled="e_isAdd" aria-required="true"></ejs-textbox>                              
                                </div>                                
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify">訂購日期</span>
                                  <ejs-datepicker id="datepicker" v-model="e_bill_date" :enabled="e_bill_state != '2'" format="yyyy-MM-dd"></ejs-datepicker>                                
                                </div>   
                                <div class="form-group col-md-4">
                                  <span class="about-title-verify" >標籤使用年限</span>
                                  <ejs-numerictextbox id="numeric" format="### 年" v-model="e_service_years" min=0 max="20" :enabled="e_bill_state != '2'" ></ejs-numerictextbox>
                                </div> 
                                <!--<div class="form-group col-md-3">
                                  <span class="about-title-verify" >標籤啟用年限</span>                      
                                  <ejs-numerictextbox id="numeric" format="### 年"  v-model="e_enable_months" min=0 max="20" :enabled="e_bill_state != '2'" ></ejs-numerictextbox>                           
                                </div>   -->
                               
                                <div class="form-group col-md-3">
                                  <span class="about-title-verify">業務人員</span>                               
                                  <ejs-dropdownlist id='sales' cssClass="custom-dropdown"  :dataSource='sales_datas' :fields='fields' v-model="e_bus_person_id"  :enabled="e_bill_state != '2'" ></ejs-dropdownlist>
                                </div>  
                                <div class="form-group col-md-3">
                                  <span class="about-title-verify">企業編號</span>
                                  <ejs-dropdownlist id='enterprise' cssClass="custom-dropdown"  :dataSource='enterprise_datas'  :select="onEnterpriseSelect" :allowFiltering='true' :fields='fields' v-model="e_enterprise_id" :enabled="e_bill_state != '2'" ></ejs-dropdownlist>
                                </div> 
                                <div class="form-group col-md-3">
                                  <span class="about-title">客戶PO</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_customer_po"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-2">
                                  <span class="about-title-verify">單況</span>
                                  <ejs-dropdownlist id='enterprise' cssClass="custom-dropdown"  :dataSource='state_datas' :fields='fields' v-model="e_bill_state" :enabled="false" ></ejs-dropdownlist>
                                </div> 
                               
                                 <div class="form-group col-md-1" v-if="e_bill_state == 0 || e_bill_state == 1" style='top: 12px;' >  
                                  <ejs-button
                                    iconCss="e-btn-sb-icons e-add-icon" v-on:click.native='onChange'
                                    cssClass="e-small e-round" aria-label="button"                                
                                  ><img width="30" src="img/avatars/change-circle-svgrepo-com.svg"></ejs-button>
                                </div> 

                                <div class="form-group col-md-4">
                                  <span class="about-title">聯絡人員</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_contact"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div> 
                                <div class="form-group col-md-4">
                                  <span class="about-title">聯絡電話</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_contact_phone"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div>    
                                <div class="form-group col-md-4">
                                  <span class="about-title">傳真號碼</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_fax"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-2">
                                  <span class="about-title">送貨國碼</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_deliver_country"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div>                                 
                                <div class="form-group col-md-6">    
                                  <span class="about-title">送貨地址</span>                              
                                  <ejs-textbox floatLabelType="Always" v-model="e_deliver_address"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div>                               
                                <div class="form-group col-md-4">
                                  <span class="about-title">交貨方式</span>
                                  <ejs-textbox floatLabelType="Always" v-model="e_deliver_mehtod"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div> 

                                <div class="form-group col-md-12">
                                  <span class="about-title">備註</span>
                                  <ejs-textbox floatLabelType="Always" :rows="1" :multiline="true" v-model="e_memo"  aria-required="true" :enabled="e_bill_state != '2'" ></ejs-textbox>    
                                </div>  
                                <div class="form-group col-md-12">                    
                      
                                  <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                    <ejs-grid ref='ref_contact_data' :dataSource='contact_datas' height='150' :allowExcelExport='true' :allowPaging='false' :allowSorting='false' :allowFiltering='false' :allowReordering='false'
                                      :toolbar='toolbarContact' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' 
                                      :editSettings='editContactSettings' :beforeRender="beforeRender" :toolbarClick="toolbarContactClick"
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound" :actionComplete="onActionComplete" >
                                      <e-columns>                   
                                        <e-column field='row_id' headerText='序號' aria-required="true" :defaultValue="contact_datas.length + 1" :isPrimaryKey='true' width='100'></e-column>       
                                        <e-column field='bill_id' headerText='bill_id' width='0' :defaultValue="e_bill_id"></e-column>                                 
                                        <e-column field='style_id' headerText='款式' width='240' editType='dropdownedit' :defaultValue="e_style_id" :edit='labstyleParams' :template="lbStyleTemplate" ></e-column>     
                                        <e-column field='style_name' headerText='款式名稱' width='0' :defaultValue="e_style_name"  :allowEditing='false'></e-column>      
                                        <e-column field='style_pages' headerText='款式張數' width='0' :defaultValue="e_style_page" :allowEditing='false' ></e-column>                             
                                        <e-column field='volumes' headerText='訂購捲數' width='120' format="N0" :defaultValue="1" :edit="stockParams" textAlign="Right" editType='numericedit' ></e-column>                   
                                        <e-column field='pages' headerText='訂購張數' format="N0" width='120' defaultValue="10000" textAlign="Right" :allowEditing='false'></e-column>                                       
                                        <e-column field='pre_deliver_date' headerText='預交日期' width='120' editType='datepickeredit' :edit='dateParams' format='yyyy-MM-dd' :defaultValue="e_now" aria-required="true" type='date'></e-column>    
                                        <e-column field='is_gift' headerText='贈品' width='120' editType='dropdownedit'  :defaultValue="false"  :edit='yesNoParams' :template="isGiftTemplate"></e-column>    
                                        <e-column field='cancel_volumes' headerText='取消捲數' textAlign="Right"  :defaultValue="0" :allowEditing='false' width='120' ></e-column>    
                                        <e-column field='cancel_pages' headerText='取消張數' textAlign="Right"  :defaultValue="0" :allowEditing='false' width='0'></e-column>    
                                        <e-column field='no_deliver_volumes' headerText='未交捲數' textAlign="Right"  :defaultValue="1" :allowEditing='false' width='120' ></e-column>    
                                        <e-column field='no_deliver_pages' headerText='未交張數'  textAlign="Right" defaultValue="10000" :allowEditing='false' width='0'></e-column>    
                                        <e-column field='is_close' headerText='結案' width='100' editType='dropdownedit' :edit='yesNoParams' :allowEditing='false'  :defaultValue="false" :template="isCloseTemplate"></e-column>    
                                        <e-column field='is_estimate' headerText='已估算' width='120' editType='dropdownedit' :edit='yesNoParams'  :defaultValue="false" :allowEditing='false' :template="isEstimateTemplate"></e-column>    
                                        <e-column field='memo' headerText='備註' width='180' :allowEditing='true' defaultValue=" "></e-column>    
                                      </e-columns>                              
                                    </ejs-grid>
                                  </ejs-tooltip>
                              </div> 
                            </div>
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script>

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { Query } from '@syncfusion/ej2-data';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { DatePickerComponent } from "@syncfusion/ej2-vue-calendars";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { NumericTextBoxComponent } from "@syncfusion/ej2-vue-inputs";
import { DropDownListComponent } from '@syncfusion/ej2-vue-dropdowns';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { ButtonComponent } from "@syncfusion/ej2-vue-buttons";
import { GridComponent, ColumnDirective, ColumnsDirective, GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";

setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
      'Print': '列印',
      'Search': '搜尋',
      'Add': '新增',
      'Edit' : '修改',
      'Delete' : '刪除',
      'Update' : '確認',
      'Cancel' : '取消'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-button': ButtonComponent,
    'ejs-toast': ToastComponent,
    'ejs-datepicker': DatePickerComponent,
    'ejs-numerictextbox': NumericTextBoxComponent,
    'ejs-grid': GridComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective,
    'ejs-dropdownlist': DropDownListComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectData: null, 
      e_isAdd: null, 
      e_bill_id : null, e_bill_date : null, e_bus_person_id : null, e_enterprise_id: null, e_customer_po : null,  e_bill_state: null,
      e_contact : null, e_contact_phone : null, e_fax : null, e_deliver_mehtod  : null, e_deliver_country : null, e_deliver_address: null, e_memo: null, 
      e_style_id : null, e_style_name : null, e_style_page : null,
      e_enable_months : null, e_service_years : null, e_now: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],

   
      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSize: 15, pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      editContactSettings: { allowEditing: true, allowAdding: true, allowDeleting: true, showAddNewRow: true, newRowPosition: 'Bottom' },
      toolbar: null,
      toolbarContact: ['Add', 'Edit', 'Delete', 'Update', 'Cancel', 'Print', 'Search'],
      datas:  [], contact_datas: [], sales_datas:  [], enterprise_datas:  [], 
      state_datas : [{ value : "0", text : "有效"}, { value : "1", text : "無效"}, { value : "2", text : "結案"}],
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      fields: { value: 'value', text: 'text', disabled: 'state' },
      stockParams : { 
        params: { 
          change: this.calculateTotalCost,
          decimals: 0,
          format: 'N0'
      } },

      yesNoParams : {
        params: {
          allowFiltering: true,
          dataSource: [{ value: true, text: '是' }, { value: false, text: '否' }],
          query: new Query(),
          fields: { value: 'value', text: 'text'},         
        },
      },
      labstyleParams : null,
      lbStyleTemplate: function () { return { 
          template: Vue.component("lbStyleTemplate", {
          template:  `<div>{{name}}</div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              name: function() {
                  return `${this.data.style_id} ${this.data.style_name}`;
              }
          }
      })}},
      isGiftTemplate: function () { return { 
          template: Vue.component("isGiftTemplate", {
          template:  `<div>{{name}}</div>`,             
          computed: {
              name: function() {
                  return this.data.is_gift ? "是" : "否";
              }
          }
      })}},
      isEstimateTemplate: function () { return { 
          template: Vue.component("isEstimateTemplate", {
          template:  `<div>{{name}}</div>`,              
          computed: {
              name: function() {
                  return this.data.is_estimate ? "是" : "否";
              }
          }
      })}},
      isCloseTemplate: function () { return { 
          template: Vue.component("isCloseTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.data.is_close ? "是" : "否";
              }
          }
      })}},
      dateTemplate: function () { return { 
          template: Vue.component("dateTemplate", {
          template:  `<div>{{name}}</div>`,            
          computed: {
              name: function() {
                  return this.formatDate(this.pre_deliver_date)
              }
          }
      })}},
      dateParams: {
        params: { 
          format: 'yyyy-MM-dd',
          // 選取後直接強制格式化
        }
      },
      
    };
  },
  methods: {    
    toolbarClick: function (args) {     
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除訂購單號${this.e_selectData.bill_id}的資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {    
        this.e_isAdd = true;
        this.e_bill_id = "";
        this.e_bill_date  = new Date();
        this.e_bus_person_id = null;
        this.e_enterprise_id = null;
        this.e_customer_po = "";
        this.e_contact  = "";
        this.e_contact_phone  = "";
        this.e_fax  = "";
        this.e_deliver_mehtod  = "";
        this.e_deliver_country  = "";
        this.e_deliver_address  = "";
        this.e_service_years = 3;
        this.e_enable_months = 36;
        this.e_memo  = "";
        this.e_bill_state = "0";
        this.editContactSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, showAddNewRow: true, newRowPosition: 'Bottom' };
        this.contact_datas = [];
        this.e_buttons = [
          {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
          {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
        ],
        this.getNumber();
        this.$refs.modalDialog.show();    
      }
      if (args.item.id == 'Edit') {
        this.recordDoubleClick(); 
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'標籤訂購單.xlsx' });
      }   
    },   
    onChange:function() {
      this.e_bill_state =  this.e_bill_state  == "0" ? "1" : "0";       
    },
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {       
      this.toolbar =  [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },      
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'];
    },
    onActionComplete(args) {
      if (args.requestType === 'save') {
        this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBStyle/ID?id=${this.contact_datas[0].style_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.e_service_years = response.data.datas.service_years;
          //console.log(response.data.datas.service_years)
      })
      .catch((error) => { this.showError(error, true) }
      )
    }
      /*  let idx = this.contact_datas.findIndex(x => x.id === args.data.id);
        console.log(args.data.row_id);
        //console.log(args.requestType);

        if (idx !== -1) {          
          //this.contact_datas.splice(idx, 1, args.data); // 更新
          this.contact_datas[idx].bill_id = this.e_bill_id;
          this.contact_datas[idx].memo = null;
          this.contact_datas[idx].cancel_pages = 0;
          this.contact_datas[idx].no_deliver_pages =  this.contact_datas[idx].no_deliver_volumes * this.contact_datas[idx].pages;         
          this.contact_datas[idx].pre_deliver_date = this.formatDate(this.contact_datas[idx].pre_deliver_date );
        }
      } else if (args.requestType === 'delete') {
        // this.contact_datas = this.contact_datas.filter(x => x.id !== args.data[0].id);
      }*/
    },
    formatDate(date) {
      console.log(date);
      if (date.length == 10) return date;
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份從 0 開始
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    toolbarContactClick: function() {    
        
    },
    rowSelected: function(args) {    
      this.e_selectRow = args.row.getAttribute('aria-rowindex');     
      this.e_selectData = args.data;   
      this.getLBOrderSub(args.data.bill_id);
      this.checkHeader();
    },
    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBOrder',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id: this.e_selectData.bill_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');         
        this.hideLoading();
        this.getLBOrderMain();       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },   
    calculateTotalCost: function() {   
      const formEle = this.$refs.ref_contact_data.$el.ej2_instances['0'].element.querySelector('form')['ej2_instances'][0];
      formEle.getInputElement('pages').value = formEle.getInputElement('style_pages').value * formEle.getInputElement('volumes').value;
      formEle.getInputElement('no_deliver_volumes').value = formEle.getInputElement('volumes').value;      
      formEle.getInputElement('no_deliver_pages').value = formEle.getInputElement('no_deliver_volumes').value * formEle.getInputElement('style_pages').value;
    },      
    delCancelClick: function() {
        DialogObj.hide();
    },    
    editOkClick: function() {     

      if(this.contact_datas.length == 0) {
        this.$refs.toastRef.show( { title: '錯誤!', content: '請新增訂購捲數', cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });
        return;
      }
      let ok = true;
      this.contact_datas.forEach((item) => {
        if (item.volumes < 1) {
          this.$refs.toastRef.show( { title: '錯誤!', content: '訂購捲數不得小於1', cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });
          ok = false;
        }
      });
      if (!ok) {
        return;
      }
      this.showLoading();
      this.axios({
          method: this.e_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBOrder',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            main: {
              bill_id : this.e_bill_id,
              bill_date : this.formatDate(this.e_bill_date),
              bill_state : this.e_bill_state,
              customer_po : this.e_customer_po,
              enterprise_id : this.e_enterprise_id,
              pages : this.e_pages,
              contact : this.e_contact,
              contact_phone : this.e_contact_phone,
              bus_person_id : this.e_bus_person_id,
              fax : this.e_fax,
              deliver_country : this.e_deliver_country,
              deliver_address : this.e_deliver_address,
              deliver_mehtod : this.e_deliver_mehtod,
              memo : this.e_memo,
              service_years : this.e_service_years,
              enable_months : this.e_service_years
            }, sub :this.contact_datas
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getLBOrderMain();       
      })
      .catch((error) => { this.showError(error, true) }
      ) 

    },  
    recordDoubleClick: function () {         
       if (this.e_selectData.bill_state == 2) {
        this.editContactSettings = { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false, newRowPosition: 'Bottom' };
        this.e_buttons = [
          {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
        ];
      } else {
        this.editContactSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, showAddNewRow: true, newRowPosition: 'Bottom' };
        this.e_buttons = [
          {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
          {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
        ];
      }
      this.e_isAdd = false;
      this.e_bill_id = this.e_selectData.bill_id; 
      this.e_bill_date = this.e_selectData.bill_date;
      this.e_bill_state = this.e_selectData.bill_state.toString();
      this.e_bus_person_id = this.e_selectData.bus_person_id;
      this.e_enterprise_id = this.e_selectData.enterprise_id;
      this.e_customer_po = this.e_selectData.customer_po;
      this.e_contact = this.e_selectData.contact;
      this.e_contact_phone = this.e_selectData.contact_phone;
      this.e_enable_months = this.e_selectData.enable_months;
      this.e_service_years = this.e_selectData.service_years;
      this.e_enable_months = this.e_selectData.enable_months;
      this.e_fax = this.e_selectData.fax;
      this.e_deliver_mehtod = this.e_selectData.deliver_mehtod;
      this.e_deliver_country = this.e_selectData.deliver_country;
      this.e_deliver_address = this.e_selectData.deliver_address;
      this.e_memo = this.e_selectData.memo; 
     
      this.$refs.modalDialog.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    onEnterpriseSelect: function(e) {
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `Enterprise/ID?id=${e.item.dataset.value}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }               
          this.e_enable_months = response.data.datas.enable_months;
          this.e_service_years = response.data.datas.service_years;
          this.e_deliver_address = response.data.datas.address;
          this.e_contact = response.data.datas.contact;
          this.e_contact_phone = response.data.datas.contact_phone;
          this.e_fax = response.data.datas.fax;
      })
      .catch((error) => { this.showError(error, true) }
      )      
    },
    getLBOrderMain: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBOrder/Main',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.e_selectData = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getLBOrderSub: function (bill_id) {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `LBOrder/Sub?bill_id=${bill_id}`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.contact_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getSales: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Account/User/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.sales_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getNumber: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/General/Number?type=order`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.e_bill_id = response.data.datas  
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getLBStyle: function () {        
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/LBStyle/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
        this.e_style_id = response.data.datas[0].value;
        this.e_style_name = response.data.datas[0].text.replace(response.data.datas[0].value, "").trim();
        this.e_style_page = response.data.datas[0].number;
        this.labstyleParams = {
          params: {
            allowFiltering: true,
            dataSource:  response.data.datas ,
            query: new Query(),
            fields: { value: 'value', text: 'text', number: 'number'},   
            select: (args) => {
              const formEle = this.$refs.ref_contact_data.$el.ej2_instances['0'].element.querySelector('form')['ej2_instances'][0]; 
              formEle.getInputElement('pages').value = args.itemData.number * formEle.getInputElement('volumes').value;
              formEle.getInputElement('style_pages').value = args.itemData.number
              formEle.getInputElement('style_name').value = args.itemData.text.replace(args.itemData.value, "").trim();
              formEle.getInputElement('no_deliver_pages').value = formEle.getInputElement('no_deliver_volumes').value * formEle.getInputElement('style_pages').value;
            },
            change: () => {
              
            },      
          },
        };
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },
    getEnterprise: function () {           
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: `/Enterprise/Dropdown`,
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.enterprise_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      )               
    },

    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getLBOrderMain();
    this.getSales();
    this.getEnterprise();
    this.getLBStyle();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}

</style>
<style lang="scss" src="../../scss/base.scss"></style>
